module.exports = (__webpack_require__(2))(45);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/body/ItemView.js from dll-reference girder_plugin_slicer_cli_web
// module id = 171
// module chunks = 0